"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _ProductDetailContext = _interopRequireDefault(require("../context/ProductDetailContext"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _it = _interopRequireDefault(require("../../locals/it.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useDescriptions = _ref => {
  let {
    exclude,
    lang = "de",
    type
  } = _ref;
  const {
    productDetailData
  } = (0, _react.useContext)(_ProductDetailContext.default);
  const {
    descriptions: productDescriptions
  } = productDetailData || {};
  const [descriptions, setDescriptions] = (0, _react.useState)([]);
  const [localsLoaded, setLocalsLoaded] = (0, _react.useState)(false);
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(() => {
    if (!(0, _isEmpty.default)(l("reactShop"))) {
      setLocalsLoaded(true);
    }
  }, [l]);
  (0, _react.useEffect)(() => {
    let _descriptions = JSON.parse(JSON.stringify(productDescriptions !== null && productDescriptions !== void 0 ? productDescriptions : []));
    if (!_descriptions.length) return;
    if (exclude) {
      _descriptions = _descriptions.filter(description => {
        if (Array.isArray(exclude)) return exclude.indexOf(description.identifier) > -1 ? false : true;
        return (description === null || description === void 0 ? void 0 : description.identifier) !== exclude;
      });
      setDescriptions(_descriptions);
      return;
    }
    if (type) {
      if (Array.isArray(type)) {
        _descriptions = _descriptions.filter(description => type.indexOf(description.identifier) > -1);
      } else {
        _descriptions = _descriptions.find(description => (description === null || description === void 0 ? void 0 : description.identifier) === type);
      }
      setDescriptions(_descriptions);
      return;
    }
    setDescriptions(_descriptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(exclude), lang, localsLoaded, productDescriptions, JSON.stringify(type)]);
  return descriptions;
};
var _default = exports.default = useDescriptions;